export const environment = {
    production: false,

    domainUrl: 'https://bombaymedicalstores-dev.portalwiz.in',
    localhostUrl: 'http://localhost:4200',

    baseUrl: 'https://bombaymedicalstores-dev.portalwiz.in/laravelapi/public/api',
    storageUrl: 'https://bombaymedicalstores-dev.portalwiz.in/laravelapi/storage/app',
};
